import { render, staticRenderFns } from "./CustomerBugOverview.vue?vue&type=template&id=c4cee6a0&scoped=true&"
import script from "./CustomerBugOverview.vue?vue&type=script&lang=js&"
export * from "./CustomerBugOverview.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBugOverview.vue?vue&type=style&index=0&id=c4cee6a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cee6a0",
  null
  
)

export default component.exports